import { fetchCredentialStatusVC, assertStatusPurposeMatches, StatusList, assertStatusListIndexWithinRange } from '@trustvc/w3c-credential-status';
import { _checkCredentialStatus } from '../../helper';
import { verifyCredential, deriveCredential } from '../../w3c-vc';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const verifyCredentialStatus = /* @__PURE__ */ __name(async (credentialStatus, type = "StatusList2021Entry", options) => {
  try {
    _checkCredentialStatus(credentialStatus, "verify");
    if (![
      "BitstringStatusListEntry",
      "StatusList2021Entry"
    ].includes(type)) {
      return {
        error: "Invalid credential status type. Expected BitstringStatusListCredentialStatus"
      };
    }
    const { statusPurpose, statusListIndex, statusListCredential } = credentialStatus ?? {};
    const index = Number.parseInt(statusListIndex);
    const vcStatusList = await fetchCredentialStatusVC(statusListCredential, options?.documentLoader);
    const statusList = vcStatusList.credentialSubject;
    assertStatusPurposeMatches(statusList, statusPurpose);
    const bitstringStatusList = await StatusList.decode(statusList);
    assertStatusListIndexWithinRange(bitstringStatusList, index);
    const DERIVE_CREDENTIAL_ERROR = "Use deriveCredential() first";
    let vcStatusListVerificationResult = await verifyCredential(vcStatusList, options);
    if (!vcStatusListVerificationResult?.verified && vcStatusListVerificationResult.error?.includes(DERIVE_CREDENTIAL_ERROR)) {
      const derivedResult = await deriveCredential(vcStatusList, []);
      vcStatusListVerificationResult = await verifyCredential(derivedResult.derived, options);
    }
    if (!vcStatusListVerificationResult?.verified) {
      const errorMessage = `Failed to verify Credential Status VC: ${vcStatusListVerificationResult.verified}`;
      const detailedError = vcStatusListVerificationResult.error ? `. Error: ${vcStatusListVerificationResult.error}` : "";
      console.error(errorMessage + detailedError);
      throw new Error(errorMessage);
    }
    const status = bitstringStatusList.getStatus(index);
    return {
      status,
      purpose: statusPurpose
    };
  } catch (err) {
    if (!(err instanceof Error)) {
      return {
        error: "An error occurred while verifying the credential status."
      };
    }
    if (err.message.includes("Could not decode encoded status list; reason:")) {
      return {
        error: `Invalid encodedList: encodedList cannot be decoded`
      };
    }
    return {
      error: err.message
    };
  }
}, "verifyCredentialStatus");

export { verifyCredentialStatus };
